import { Box, Container, Grid, Link, LinkProps, Typography, useMediaQuery } from '@mui/material'
import { theme } from '~/lib/theme'
import { EXTERNAL_LINKS } from '~/lib/externalLinks'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

const links = [
  {
    label: '禁止事項',
    url: EXTERNAL_LINKS.PROHIBITED_ITEMS,
  },
  {
    label: 'クレジットカード決済規定',
    url: EXTERNAL_LINKS.CREDIT_CARD_PAYMENT_TERMS,
  },
  {
    label: '利用規約',
    url: EXTERNAL_LINKS.TERMS_OF_SERVICE,
  },
  {
    label: 'プライバシーポリシー',
    url: EXTERNAL_LINKS.PRIVACY_POLICY,
  },
  {
    label: '会社概要',
    url: EXTERNAL_LINKS.COMPANY_INFO,
  },
] as const satisfies Array<{ label: string; url: string }>

export const AppFooter = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Box
      sx={{
        width: '100%',
        borderTop: '1px solid',
        borderColor: 'divider',
        pt: { xs: 4, md: 5 },
        // モバイルの場合はボトムナビゲーションが表示されるので、かぶらないように下への余白を多く取る
        pb: { xs: 10, md: 5 },
        px: { xs: 3, md: 5 },
      }}
      component="footer"
    >
      <Container maxWidth="lg">
        {!isMobile && (
          <Box sx={{ mb: 3 }}>
            <img
              src="/toridori_marketing_logo_1.png"
              alt="toridori marketing"
              style={{
                width: '200px',
              }}
            />
          </Box>
        )}
        <Grid container gap={3}>
          {links.map((link) => (
            <Grid
              key={link.url}
              size={{
                xs: 12,
                md: 4,
              }}
            >
              <FooterLink href={link.url} target="_blank" rel="noopener noreferrer">
                {link.label}
              </FooterLink>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  )
}

const FooterLink = (props: LinkProps) => (
  <Link
    {...props}
    color={theme.palette.text.secondary}
    underline="hover"
    sx={{ cursor: 'pointer', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}
  >
    <Typography variant="body2" color="text.primary">
      {props.children}
    </Typography>
    <OpenInNewIcon fontSize="small" />
  </Link>
)
